import axiosClient from "api/axiosClient";

export const getResumeRevamp = async () => {
  try {
    const response = await axiosClient.get("/api/resume-revamp");
    return response.data;
  } catch (error) {
    throw error;
  }
};
